import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SearchHotelFormComponent } from './search-hotel-form.component';
import { SegmentModule } from 'libraries/module/formbuilder/fieldsets/segment-fieldset/segment.fieldset.module';
import { IqbhMapModule } from 'libraries/hotel/components/iqbh-map/iqbh-map.module';
import { QuantityFieldsetModule } from 'libraries/module/formbuilder/fieldsets/quantity-fieldset/quantity-fieldset.module';
import { TextFieldModule } from 'libraries/module/formbuilder/fields/text-field/text-field.module';
import { ChipsFieldModule } from 'libraries/module/formbuilder/fields/chips-field/chips-field.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { AgeFieldsetModule } from 'libraries/module/formbuilder/fieldsets/age-fieldset/age-fieldset.module';
import { RoomingFieldsetModule } from 'libraries/module/formbuilder/fieldsets/rooming-fieldset/rooming-fieldset.module';
import { MultiselectModule } from 'libraries/module/formbuilder/fields/multiselect/multiselect.module';
import { ConfigurationResourceModule } from 'libraries/service/resources/configuration/configurationResource.module';
import { SharedData } from '../../shared-data';
import { SearchHotelFormService } from './services/search-hotel-form.service';
import { RatingFieldModule } from '../../../module/formbuilder/fields/rating-field/rating-field.module';
import { PermissionModule } from '../../../permission/permission.module';
import { NotificationModule } from "../../../component/notification/notification.module";
import { GeopositionModule } from 'libraries/service/geoposition/geoposition.module';
import { TravellerModule } from 'libraries/service/traveller/traveller.module';
import { DatePipeModule } from "libraries/date/date.module";
import { AddressFieldsetModule } from "libraries/module/formbuilder/fieldsets/address-fieldset/address-fieldset.module";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";

@NgModule({
    declarations: [
        SearchHotelFormComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SegmentModule,
        IqbhMapModule,
        QuantityFieldsetModule,
        TextFieldModule,
        ChipsFieldModule,
        MultiselectModule,
        ButtonModule,
        AgeFieldsetModule,
        RoomingFieldsetModule,
        //TODO NG UPGRADE NgxErrorsModule,
        ConfigurationResourceModule,
        RatingFieldModule,
        CheckboxModule,
        PermissionModule,
        NotificationModule,
        GeopositionModule,
        TravellerModule,
        DatePipeModule,
        AddressFieldsetModule,
        HostAliasPipeModule,
        FontAwesomeModule,
        NumberModule
    ],
    exports: [
        SearchHotelFormComponent,
    ],
    providers: [
        SharedData,
        SearchHotelFormService,
    ],
})
export class SearchHotelFormModule {
}
